import { useGLTF } from '@react-three/drei'
import React,{useRef} from 'react'
import skyScene from '../assets/3d/sky.glb'
import { useFrame } from '@react-three/fiber'
const Sky = () => {
    const sky=useGLTF(skyScene);
    const skyRef=useRef();

    useFrame(()=>{
      
    })

  return (
    <mesh ref={skyRef}>
        <primitive object={sky.scene}/>
    </mesh>
  )
}

export default Sky